import { Routes } from '@angular/router';
import { vaultModuleAccessGuard } from '@nebula/shared-vault/data-access';
import { VaultAccessDeniedPageComponent } from './feature-vault/src/lib/access-denied/vault-access-denied-page.component';
import { VaultComponent } from './feature-vault/src/lib/vault/vault.component';
import { DashboardComponent } from './feature-vault/src/lib/dashboard/dashboard.component';
import { PreservationComponent } from './feature-vault/src/lib/preservation/preservation.component';
import { IngestComponent } from './feature-vault/src/lib/ingest/ingest.component';
import { RetentionComponent } from './feature-vault/src/lib/retention/retention.component';
import { LegalComponent } from './feature-vault/src/lib/legal/legal.component';
import { ReportsComponent } from './feature-vault/src/lib/reports/reports.component';
import { CloudComponent } from './feature-vault/src/lib/cloud/cloud.component';
import { NotificationsComponent } from './feature-vault/src/lib/notifications/notifications.component';
import { AuditComponent } from './feature-vault/src/lib/audit/audit.component';
import { SettingsShellComponent } from './feature-vault/src/lib/settings/settings-shell.component';
import { SettingsMainComponent } from './feature-vault/src/lib/settings/settings-main.component';
import { AdminServersComponent } from './feature-vault/src/lib/admin-servers/admin-servers.component';
import { UserProfileComponent } from './feature-vault/src/lib/settings/user-profile.component';
import { AdminDashboardComponent } from './feature-vault/src/lib/admin-dashboard/admin-dashboard.component';
import { TenantsComponent } from './feature-vault/src/lib/tenants/tenants.component';
import { AdminUsersComponent } from './feature-vault/src/lib/admin-users/admin-users.component';
import { PermissionsComponent } from './feature-vault/src/lib/permissions/permissions.component';
import { RepositoryAdminComponent } from './feature-vault/src/lib/repository-admin/repository-admin.component';
import { PreservationMessagesComponent } from './feature-vault/src/lib/preservation-messages/preservation-messages.component';
import { INGEST_ROUTES } from './ingest.routes';

export const VAULT_ROUTES: Routes = [
  {
    path: '',
    component: VaultComponent,
    title: 'Nebula Vault',
    canActivateChild: [vaultModuleAccessGuard],
    data: {
      showSidebar: true,
      showHeader: true,
      showBreadcrumb: true,
    },
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'access-denied',
        component: VaultAccessDeniedPageComponent,
        title: 'Acceso restringido',
        data: { breadcrumb: 'Acceso restringido' },
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        title: 'Inicio',
        data: { breadcrumb: 'Inicio' },
      },

      {
        path: 'preservation',
        component: PreservationComponent,
        title: 'Preservación Digital',
        data: { breadcrumb: 'Preservación Digital' },
      },

      {
        path: 'vault',
        component: IngestComponent,
        title: 'Carga de Documentos',
        data: { breadcrumb: 'Carga de Documentos' },
        children: INGEST_ROUTES,
      },
      // Compatibilidad para rutas antiguas colapsadas (/layout/vault/<ingest-child>).
      { path: 'projects', redirectTo: 'vault/projects', pathMatch: 'full' },
      { path: 'projects/:id', redirectTo: 'vault/projects/:id', pathMatch: 'full' },
      { path: 'projects/:id/upload', redirectTo: 'vault/projects/:id/upload', pathMatch: 'full' },
      { path: 'upload', redirectTo: 'vault/upload', pathMatch: 'full' },
      { path: 'files', redirectTo: 'vault/files', pathMatch: 'full' },
      { path: 'files/:projectId', redirectTo: 'vault/files/:projectId', pathMatch: 'full' },

      {
        path: 'retention',
        component: RetentionComponent,
        title: 'Retención Documental',
        data: { breadcrumb: 'Retención Documental' },
      },

      {
        path: 'legal-hold',
        component: LegalComponent,
        title: 'Custodia Legal ',
        data: { breadcrumb: 'Custodia Legal' },
      },
      {
        path: 'reports',
        component: ReportsComponent,
        title: 'Reportes Generales',
        data: { breadcrumb: 'Reportes Generales' },
      },
      {
        path: 'cloud',
        component: CloudComponent,
        title: 'Respaldo Externo',
        data: { breadcrumb: 'Respaldo Externo' },
      },
      {
        path: 'notifications',
        component: NotificationsComponent,
        title: 'Notificaciones',
        data: { breadcrumb: 'Notificaciones' },
      },
      {
        path: 'audit',
        component: AuditComponent,
        title: 'Auditoría',
        data: { breadcrumb: 'Auditoría' },
      },
      {
        path: 'settings',
        component: SettingsShellComponent,
        title: 'Configuración',
        data: { breadcrumb: 'Configuración' },
        children: [
          {
            path: '',
            component: SettingsMainComponent,
            title: 'Configuración',
            data: { breadcrumb: 'General' },
          },
          {
            path: 'profile',
            component: UserProfileComponent,
            title: 'Perfil',
            data: { breadcrumb: 'Perfil' },
          },
        ],
      },
      {
        path: 'admin/dashboard',
        component: AdminDashboardComponent,
        title: 'Admin Dashboard',
        data: { breadcrumb: 'Admin Dashboard' },
      },
      {
        path: 'admin/tenants',
        component: TenantsComponent,
        title: 'Gestión de Empresas',
        data: { breadcrumb: 'Gestión de Empresas' },
      },
      {
        path: 'admin/users',
        redirectTo: 'admin/user',
        pathMatch: 'full',
      },
      {
        path: 'admin/user',
        component: AdminUsersComponent,
        title: 'Gestión de Usuarios',
        data: { breadcrumb: 'Gestión de Usuarios' },
      },

      {
        path: 'admin/module-permissions',
        component: PermissionsComponent,
        title: 'Permisos',
        data: { breadcrumb: 'Permisos' },
      },
      {
        path: 'admin/servers',
        component: AdminServersComponent,
        title: 'Configuración Servidores',
        data: { breadcrumb: 'Configuración Servidores' },
      },

      {
        path: 'preservation-messages',
        component: PreservationMessagesComponent,
        title: 'Mensajes Informativos',
        data: { breadcrumb: 'Mensajes Informativos' },
      },

      {
        path: 'repository-admin',
        component: RepositoryAdminComponent,
        title: 'Bóveda Digital',
        data: { breadcrumb: 'Bóveda Digital' },
      },
    ],

    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
  },
];
